<div id="desktop-catalog">
    <div class="table-root">
        <table>
            <tr class="header-row">
                <th>ID</th>
                <th>Size</th>
                <th>Progress</th>
            </tr>
        </table>
    </div>
    <details>
        <summary>Filters</summary>
        <div class="filters">
            <span class="label">ID:</span>
            <input id="catalog-filter-id" type="text" size="10">
            <!-- <div class="filter-separator"></div> -->
            <span class="label">Min. Width:</span>
            <input id="catalog-filter-min-width" class="number-input" type="number" size="3">
            <span class="label">Max. Width:</span>
            <input id="catalog-filter-max-width" class="number-input" type="number" size="3">
            <!-- <div class="filter-separator"></div> -->
            <span class="label">Min. Height:</span>
            <input id="catalog-filter-min-height" class="number-input" type="number" size="3">
            <span class="label">Max. Height:</span>
            <input id="catalog-filter-max-height" class="number-input" type="number" size="3">
            <!-- <div class="filter-separator"></div> -->
            <button id="btn-catalog-apply-filters">Refresh</button>
        </div>
    </details>
</div>